// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../common/ProgressBar';
import { FormattedNumber } from 'react-intl';
import FormattedGB from '../common/FormattedGB';


class SourcesProgressBar extends Component {

  renderTotalRequiredDataPerDay() {
    const { isPercentage, dataIndexed, dataRequired } = this.props;

    if (isPercentage) {
      return (
        <p>
          <FormattedGB className='data-indexed' value={dataIndexed} /> of&nbsp;
          <FormattedGB className='data-required' value={dataRequired} /> Total Required Data Per Day
        </p>
      );
    }

    return (
      <p><FormattedGB className='data-required' value={dataRequired} /> Total Required Data Per Day</p>
    );
  }

  renderPercentIndexed() {
    const { isPercentage, percentIndexed } = this.props;

    if (isPercentage) {
      return (
        <p>
          <span className='percent-indexed'>
            <FormattedNumber value={percentIndexed / 100} style='percent' maximumFractionDigits={1} />
          </span> indexed per day
        </p>
      );
    }
  }

  renderProgressBar() {
    const {
      progressBarHeight,
      percentIndexed,
      dataRequired,
      totalDataRequired,
      isPercentage
    } = this.props;

    const defaultProps = {
      height: progressBarHeight,
      stripeColor: '#2D2D2D',
      backgroundColor: 'green'
    };

    if (isPercentage) {
      return (
        <ProgressBar
          percent={percentIndexed / 100}
          {...defaultProps}
        />
      );
    } else {
      let barWidth = 1;
      if (totalDataRequired > 0) {
        barWidth = dataRequired / totalDataRequired * 100;
      }
      return (
        <ProgressBar
          width={`${barWidth}%`}
          {...defaultProps}
        />
      );
    }

  }

  renderCiscoTotalSplit() {
    const { isPercentage, ciscoDataPerDay, nonCiscoDataPerDay } = this.props;

    if (!isPercentage) return null;

    return (
      <div className='sources-progress-bar__cisco-split'>
        <span className='sources-progress-bar__cisco-split-row'>
          <FormattedNumber value={nonCiscoDataPerDay} maximumFractionDigits={1} /> GB/day Non Cisco
        </span>
        <span className='sources-progress-bar__cisco-split-row'>
          <FormattedNumber value={ciscoDataPerDay} maximumFractionDigits={1} /> GB/day Cisco Data
        </span>
      </div>
    );
  }

  renderCiscoIndexedSplit() {
    const { isPercentage, ciscoDataIndexed, nonCiscoDataIndexed } = this.props;

    if (!isPercentage) return null;

    return (
      <div className='sources-progress-bar__cisco-split'>
        <span className='sources-progress-bar__cisco-split-row'>
          <FormattedNumber value={nonCiscoDataIndexed} maximumFractionDigits={1} /> GB/day indexed Non Cisco
        </span>
        <span className='sources-progress-bar__cisco-split-row'>
          <FormattedNumber value={ciscoDataIndexed} maximumFractionDigits={1} /> GB/day indexed Cisco Data
        </span>
      </div>
    );
  }

  render() {
    return (
      <div className='sources-progress-bar'>
        {this.renderTotalRequiredDataPerDay()}
        {this.renderCiscoTotalSplit()}
        {this.renderProgressBar()}
        {this.renderPercentIndexed()}
        {this.renderCiscoIndexedSplit()}
      </div>
    );
  }
}

SourcesProgressBar.defaultProps = {
  progressBarHeight: 20,
  ciscoDataPerDay: 0,
  nonCiscoDataPerDay: 0,
  ciscoDataIndexed: 0,
  nonCiscoDataIndexed: 0
};

SourcesProgressBar.propTypes = {
  dataIndexed: PropTypes.number.isRequired,
  dataRequired: PropTypes.number.isRequired,
  progressBarHeight: PropTypes.number,
  percentIndexed: PropTypes.number,
  isPercentage: PropTypes.bool.isRequired,
  totalDataRequired: PropTypes.number.isRequired,
  ciscoDataPerDay: PropTypes.number,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number
};

export default SourcesProgressBar;



// WEBPACK FOOTER //
// ./src/components/sources/SourcesProgressBar.js